import { useSelector, useDispatch } from 'react-redux';
import styled, { css } from 'styled-components';
import SportsbookTopNavigation from './sportsbook-top-navigation';
import { AppDispatch } from '~/store/types';
import { useCallback } from 'react';
import { closeSearch, selectIsSearchOpen } from '../search/sportsbook-search-duck';
import useOpenBets from '../open-bets/use-open-bets';
import { selectIsAuthenticated } from '../../sportsbook-root-selectors';
import { SPORTSBOOK_TEXT_KEYS } from '../../sportsbook-text-keys';
import useTranslations from '../../../../translation/use-translations';
import SportsbookTopbarWrapper from './sportsbook-top-bar-wrapper';
import {
	SearchDesktopPopoverContainer,
	SearchMobilePopoverContainer
} from '~/components/sportsbook/lobby/features/search/sportsbook-search-async';
import { isSmallerSelector } from '~/components/layout/mediaquery';

const StaticTopNavigation = styled(SportsbookTopNavigation)<{ isMobileSearchOpen: boolean }>`
	opacity: 1;
	transition: opacity 0.2s ease-out;

	${({ isMobileSearchOpen }) =>
		isMobileSearchOpen &&
		css`
			opacity: 0;
		`};
`;

const SearchWrapper = styled.div`
	flex: 1 0 100px;
	max-width: 300px;
`;

/**
 * Display navigation and desktop-seach-container on top of sportsbook content.
 * */
const SportsbookTopbarContainer = () => {
	const dispatch: AppDispatch = useDispatch();
	const isAuthenticated = useSelector(selectIsAuthenticated);
	const isSmaller = useSelector(isSmallerSelector);
	const { translations } = useTranslations(SPORTSBOOK_TEXT_KEYS);
	const { betsCount: openBetsCount } = useOpenBets();

	const isSearchOpen = useSelector(selectIsSearchOpen);
	const handleLinkClick = useCallback(() => dispatch(closeSearch()), [dispatch]);

	return (
		<SportsbookTopbarWrapper>
			<StaticTopNavigation
				translations={translations}
				openBetsCount={openBetsCount}
				hasMyBets={isAuthenticated}
				onLinkClick={handleLinkClick}
				isMobileSearchOpen={isSearchOpen && isSmaller}
			/>
			{isSmaller ? (
				<SearchMobilePopoverContainer />
			) : (
				<SearchWrapper>
					<SearchDesktopPopoverContainer />
				</SearchWrapper>
			)}
		</SportsbookTopbarWrapper>
	);
};

export default SportsbookTopbarContainer;
